"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _PreviewLabel = _interopRequireDefault(require("../PreviewLabel"));

require("./PreviewMedia.scss");

var _PreviewImage = _interopRequireDefault(require("./PreviewImage"));

var _PreviewVideo = _interopRequireDefault(require("./PreviewVideo"));

var _PreviewAudio = _interopRequireDefault(require("./PreviewAudio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const templates = {
  "image": _PreviewImage.default,
  "video": _PreviewVideo.default,
  "audio": _PreviewAudio.default
}; // Class

class PreviewMedia extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getMediaType", () => {
      const media = this.props.formData.media;

      if (!media) {
        return undefined;
      }

      const mediaType = media.mediaType,
            imageUrl = media.imageUrl;

      if (mediaType) {
        return mediaType;
      } else if (imageUrl) {
        return "image";
      }

      return undefined;
    });

    _defineProperty(this, "getClassName", () => {
      const mediaType = this.getMediaType();
      let classNames = [];
      classNames.push('field__media');

      if (mediaType) {
        classNames.push('media--' + mediaType);
      }

      return classNames.join(' ');
    });

    _defineProperty(this, "renderMedia", () => {
      const _this$props = this.props,
            formData = _this$props.formData,
            format = _this$props.format;
      const mediaId = formData.mediaId,
            media = formData.media,
            content = formData.content;

      const _ref = media || {},
            title = _ref.title,
            mediaType = _ref.mediaType,
            imageUrl = _ref.imageUrl,
            resources = _ref.resources;

      const className = this.getClassName();
      let MediaTemplate;

      if (templates[mediaType] && resources) {
        MediaTemplate = templates[mediaType];
      } else if (imageUrl) {
        MediaTemplate = templates["image"];
      }

      if (MediaTemplate) {
        return _react.default.createElement("div", {
          className: className,
          "data-format": format
        }, _react.default.createElement(MediaTemplate, this.props));
      }

      return _react.default.createElement("div", {
        className: className,
        "data-format": format
      }, _react.default.createElement("div", {
        className: "media__preview"
      }, _react.default.createElement("h2", {
        className: "media__title"
      }, title), _react.default.createElement("h2", {
        className: "media__description"
      }, mediaType)));
    });

    _defineProperty(this, "renderContent", () => {
      const content = this.props.formData.content;

      if (!content) {
        return false;
      }

      return false;
      const headline = content.headline,
            description = content.description,
            category = content.category,
            creditLine = content.creditLine;

      if (creditLine) {
        return _react.default.createElement("figcaption", {
          className: "media__caption"
        }, _react.default.createElement("strong", null, headline), " ", ' ', description, " ", ' ', _react.default.createElement("em", {
          className: "media__credit",
          "data-prefix": category
        }, creditLine));
      }

      return _react.default.createElement("figcaption", {
        className: "media__caption"
      }, _react.default.createElement("strong", null, headline), " ", ' ', description);
    });
  }

  render() {
    const _this$props2 = this.props,
          id = _this$props2.id,
          formData = _this$props2.formData;

    if (!formData) {
      return false;
    }

    const mediaType = this.getMediaType();
    return _react.default.createElement("figure", {
      className: "admin-preview__field  field--media"
    }, _react.default.createElement(_PreviewLabel.default, {
      id: id || "media",
      type: mediaType
    }), this.renderMedia(), this.renderContent());
  }

}

_defineProperty(PreviewMedia, "defaultProps", {
  format: "16:9"
});

var _default = PreviewMedia;
exports.default = _default;
module.exports = exports.default;